<div class="email-leader-modal-container">
  <form #emailForm="ngForm" (ngSubmit)="submit()">
    <div class="crm-modal-header py-2 px-3">
      Email {{ leaderName }}
      <span class="text-transform-none" *ngIf="crmItem"> - {{ crmItem.name }}</span>
    </div>
    <div class="modal-body">
      <div class="form-group mb-3">
        <label for="subject">
          Subject<span class="red">*</span>
        </label>
        <input
          type="text"
          name="subject"
          id="subject"
          [(ngModel)]="subject"
          class="form-control"
          placeholder="Enter email subject"
          required
          #subjectInput="ngModel">
        <div *ngIf="subjectInput.invalid && subjectInput.touched" class="text-danger mt-1">
          Subject is required
        </div>
      </div>

      <div class="form-group">
        <label for="body">
          Body<span class="red">*</span>
        </label>
        <textarea
          name="body"
          id="body"
          [(ngModel)]="body"
          class="form-control"
          placeholder="Enter email body"
          rows="10"
          required
          #bodyInput="ngModel"></textarea>
        <div *ngIf="bodyInput.invalid && bodyInput.touched" class="text-danger mt-1">
          Body is required
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="close()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="emailForm.invalid">
        Send Email
      </button>
    </div>
  </form>
</div>
